export default "__VITE_ASSET__CAEKJYzw__"